<!-- Portfolio view-->
@if (homeworkService.portfolioLink && !applicationStateService.userData.isTeacher) {
    <div class="portfolio-container">
        <h3 [class.student]="applicationStateService.userData.isTeacher" class="title">Mein Portfolio</h3>
        <button (click)="openPortfolio()" class="title btn btn-round btn-semibold m-auto">Portfolio ansehen</button>
    </div>
}

